import { useEffect, useState } from 'react';
import { useRouteError } from 'react-router-dom';
import * as Sentry from '@sentry/react';

import homegrownFullLogoSRC from 'Assets/homegrown-logo-full.png';
import notFoundImage from 'Assets/images/404-item-image.png';

import { SUPPORT_EMAIL, clientAppRoot } from '../constants.ts';

const isProduction = import.meta.env.VITE_APP_ENVIRONMENT === 'production';

export function RouterErrorComponent() {
    const error = useRouteError() as Error;
    const [sentryEventId, setSentryEventId] = useState<string>();

    useEffect(() => {
        setSentryEventId(Sentry.captureException(error));
    }, [error]);

    return (
        <div className="relative min-h-screen px-4 flex items-center justify-center bg-background font-Roboto">
            <img
                src={homegrownFullLogoSRC}
                alt="Homegrown"
                className="absolute top-6 left-6 h-10"
            />
            <div className="w-full max-w-[550px] flex flex-col items-center">
                <img
                    src={notFoundImage}
                    alt="Error"
                    className="w-[100px] min-[600px]:w-[132px] aspect-132/109 object-cover object-top"
                />
                <div className="z-[1] px-5 py-6 min-[600px]:p-[30px] flex flex-col items-center self-stretch gap-3.5 min-[600px]:gap-5 rounded-[20px] bg-foreground text-background">
                    <p className="text-center text-[24px] min-[600px]:text-[32px] font-Telegraf font-bold tracking-[0.00938em]">
                        Something went wrong
                    </p>
                    <p className="text-center text-[16px] min-[600px]:text-[24px] font-normal tracking-[0.00938em] leading-[1.2]">
                        An unexpected error occurred. Please try again.
                    </p>
                </div>
                <button
                    type="button"
                    onClick={() => (window.location.href = clientAppRoot)}
                    className="mt-6 h-10 px-8 inline-flex items-center justify-center rounded-lg bg-foreground shadow-sm hover:bg-foreground/90 text-sm font-medium text-background transition-colors"
                >
                    Go to Home
                </button>
                {!isProduction && sentryEventId ? (
                    <p
                        title={error?.stack || error?.message || String(error)}
                        className="mt-4 text-center text-[12px] tracking-[0.00938em] text-muted-foreground cursor-help"
                    >
                        Error ID: {sentryEventId}
                    </p>
                ) : null}
            </div>
            <p className="absolute bottom-6 text-center text-[14px] min-[600px]:text-[16px] font-normal tracking-[0.00938em] text-foreground">
                Need support? Reach out to{' '}
                <a href={`mailto:${SUPPORT_EMAIL}`} className="underline">
                    {SUPPORT_EMAIL}
                </a>
            </p>
        </div>
    );
}
